import React, {useState, useEffect} from "react";
import styled from "@emotion/styled/macro";
import { 
    Grid2 as Grid,
    Typography,
    Stack,
    Tooltip
} from "@mui/material";
import { Link } from "react-router-dom/cjs/react-router-dom";
import MailIcon from '@mui/icons-material/ForwardToInboxOutlined';
import PhoneIcon from '@mui/icons-material/LocalPhoneOutlined';
import GithubIcon from './assets/github-mark-white.png';
import LinkedInIcon from './assets/linkedin-logo.png';

import ROUTES from '../../constants/routes';
import FOOTER from './constants'

const StyledGridContainer = styled(Grid)`
    height: 100%;
    align-items: center;
    font-family: poppins;
    min-width: 200px;
    margin: 1vh auto;
    margin-bottom: 0;
    background-color: black;
    overflow: hidden;
`;

const StyledFooterGridItem = styled(Grid)`
    width: 100vw;
    background-color: black;
    text-align: center;
    min-height: 12.5vh;
`;

const StyledFooterHeading = styled(Typography)`
    font-family: poppins;
    color: white;
    margin-top: 2vh;
    margin-bottom: 1vh;
    font-size: 16px;
    text-decoration: underline;
    pointer-events: none;
`;
const StyledFooterBody = styled(Typography)`
    font-family: poppins;
    color: white;
    margin-top: 5px;
    margin-bottom: 5px;
    font-size: 13px;
    `;

const StyledFooterInternalLink = styled(Link)`
    text-decoration: none;
    font-family: poppins;
    color: white;
    transition: all 0.10s;

    &:hover {
        scale: 1.10;
    }
`;
const StyledFooterLink = styled.a`
    text-decoration: none;
    font-family: poppins;
    color: white;
    transition: all 0.10s;

    &:hover {
        scale: 1.10;
    }
`;
const StyledFooterPhoneNumber = styled.span`
    font-family: poppins;
    transition: all 0.10s;
    user-select: none;

    &:hover {
        cursor: grab;
        scale: 1.05;
    }
    &:active {
        cursor: grabbing;
        scale: 1.05;
    }
`;
const StyledMailIcon = styled(MailIcon)`
    height: 20px;
    width: 20px;
`;
const StyledPhoneIcon = styled(PhoneIcon)`
    height: 20px;
    width: 20px;
`;
const StyledFooterIcon = styled.img`
    height: 20px;
    width: 20px;
`;
const StyledFooterLinkStack = styled(Stack)`
    justify-content: center;
`;
const StyledFooterGridItemCopyright = styled(Grid)`
    width: 100vw;
    background-color: black;
    text-align: center;
`;
const StyledFooterCopyright = styled(Typography)`
    font-family: poppins;
    color: white;
    margin-top: 5vh;
    margin-bottom: 20px;
    font-size: 10px;
    pointer-events: none;
`;

const Footer = () => {
    const [copySuccessful, setCopySuccessful] = useState(false);
    
    useEffect(() => {
        if(copySuccessful){
            setTimeout(() => {
                setCopySuccessful(false);
            }, 1000);
        }
    },[copySuccessful]);

    const copyNumberToClipboard = async () => {
        await navigator.clipboard.writeText(FOOTER.BUSINESS_PHONE_NUMBER);
        setCopySuccessful(true);
    }


    return ( 
        <StyledGridContainer container>
            <StyledFooterGridItem size={{xs:12, sm:4, md:4}}>
                <StyledFooterHeading>
                    Information
                </StyledFooterHeading>
                <StyledFooterBody>
                    <StyledFooterLinkStack alignItems="center" direction="row" gap={1}>
                        <StyledFooterInternalLink to={ROUTES.ABOUT_SITE}>
                            About this site
                        </StyledFooterInternalLink>
                    </StyledFooterLinkStack>
                </StyledFooterBody>
                <StyledFooterBody>
                    <StyledFooterLinkStack alignItems="center" direction="row" gap={1}>
                        <StyledFooterBody component={StyledFooterLink} href={FOOTER.BLOG_URL}>
                            Blog
                        </StyledFooterBody>
                    </StyledFooterLinkStack>
                </StyledFooterBody>
            </StyledFooterGridItem>
            <StyledFooterGridItem size={{xs:12, sm:4, md:4}}>
                <StyledFooterHeading>
                    Contact
                </StyledFooterHeading>
                <StyledFooterBody >
                        <StyledFooterLinkStack alignItems="center" direction="row" gap={1}>
                            <StyledMailIcon />
                            <StyledFooterBody component={StyledFooterLink} href={`mailto:${FOOTER.BUSINESS_EMAIL}?subject=${FOOTER.MAILTO_SUBJECT}`}>
                                Email
                            </StyledFooterBody>
                        </StyledFooterLinkStack>
                </StyledFooterBody>
                <StyledFooterBody>
                    <StyledFooterLinkStack alignItems="center" direction="row" gap={1}>
                        <StyledPhoneIcon />
                        <Tooltip followCursor title={copySuccessful? "Phone Number Copied!" : "Copy Number"} placement="top">
                            <StyledFooterPhoneNumber onClick={copyNumberToClipboard} disabled={copySuccessful}>
                                {FOOTER.BUSINESS_PHONE_NUMBER}
                            </StyledFooterPhoneNumber>
                        </Tooltip>
                    </StyledFooterLinkStack>
                </StyledFooterBody>
            </StyledFooterGridItem>
            <StyledFooterGridItem size={{xs:12, sm:4, md:4}}>
                <StyledFooterHeading>
                    Socials
                </StyledFooterHeading>
                <StyledFooterBody>
                    <StyledFooterLinkStack alignItems="center" direction="row" gap={1}>
                        <StyledFooterIcon src={GithubIcon} alt="github icon"/>
                        <StyledFooterBody component={StyledFooterLink} href={FOOTER.GITHUB_URL}>
                            Github
                        </StyledFooterBody>
                    </StyledFooterLinkStack>
                </StyledFooterBody>
                <StyledFooterBody>
                <StyledFooterLinkStack alignItems="center" direction="row" gap={1}>
                    <StyledFooterIcon src={LinkedInIcon} alt="linkedin icon"/>
                    <StyledFooterBody component={StyledFooterLink} href={FOOTER.LINKEDIN_URL}>
                        LinkedIn
                    </StyledFooterBody>
                    </StyledFooterLinkStack>
                </StyledFooterBody>
            </StyledFooterGridItem>
            <StyledFooterGridItemCopyright size={{xs:12, sm:12, md:12}}>
                <StyledFooterCopyright>
                    © Copyright 2025, Made by Keane Le
                </StyledFooterCopyright>
            </StyledFooterGridItemCopyright>
        </StyledGridContainer>
    );
}
 
export default Footer;